import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
export default ({
  setOrderBy,
  order_by,
  setTimelineListTask,
  setIsLoading,
  setPage,
  setStatusId,
}) => {
  const [filterOptions] = useState([
    {
      label: "All",
      key: null,
    },
    {
      label: "Completed",
      key: 2,
    },
    {
      label: "Incomplete",
      key: 1,
    },
  ]);

  const refreshTimline = () => {
    setPage(1);
    setIsLoading(true);
    setTimelineListTask([]);
  };

  const orderFiler = () => {
    refreshTimline();
    if (order_by === "newest") {
      return setOrderBy("oldest");
    }

    setOrderBy("newest");
  };

  const filterTimeline = (event) => {
    refreshTimline();

    setStatusId(
      event.currentTarget.value === "All" ? null : event.currentTarget.value
    );
  };

  return (
    <div className="text-right " style={{ display: "flex" }}>
      <span className="sort-filter" onClick={orderFiler}>
        <span className="sortName">Sort by </span>
        {order_by === "newest" && (
          <FontAwesomeIcon icon={faArrowUp} className="ms-1 fas" />
        )}
        {order_by === "oldest" && (
          <FontAwesomeIcon icon={faArrowDown} className="ms-1 fas" />
        )}
      </span>
      <select
        onChange={filterTimeline}
        className="form-select d-inline-block"
        aria-label="Default select example"
      >
        {filterOptions.map((options, key) => (
          <option key={key} value={options.key}>
            {options.label}
          </option>
        ))}
      </select>
    </div>
  );
};
